'use strict';

var self = module.exports = {

  init: function () {

    $('[data-js="cabbage-return"]').click(function() {

      // Resetta allo stato iniziale l'editor
      canvas.reset();

      // Resetta i campi del form contatti
      $('input[type="text"], input[type="email"]').val('');
      $('input[type="checkbox"]').removeAttr('checked');
      $('select').empty();
      $('.selectize-input')
        .find('.item')
        .empty()
        .removeAttr('data-value');

      // ripristina il pulsante invio form e nasconde il loading
      $('[data-js="delivery-button"]').show();
      $('[data-js="delivery-loading"]').empty();

      // rimuove gli eventuali errori nel form
      $('[data-js="form-error-text"]').empty();

      // Resetta il titolo dell'opera
      $('.artwork-title__form-input').val('Senza Titolo');

      $('form')
        .find('[data-js="form-error-visual"]')
        .removeClass('form__field_has_error checkbox__indicator_has_error');


      $.fn.fullpage.silentMoveTo(2);
    });

  }
}

self.init();
